import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from './design-system';

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--color-background)' }}>
      {/* Navigation */}
      <nav className="shadow-sm border-b" style={{ backgroundColor: 'white', borderColor: 'rgba(0, 0, 0, 0.1)' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center" style={{ height: '64px' }}>
            <div className="flex items-center gap-4">
              <Link to="/">
                <Button variant="outline" size="small" className="flex items-center gap-2">
                  <ArrowLeft className="h-4 w-4" />
                  <span>Back</span>
                </Button>
              </Link>
              <div className="text-xl md:text-2xl font-bold" style={{ color: 'var(--color-primary)' }}>TheraEngage</div>
            </div>
          </div>
        </div>
      </nav>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div style={{ backgroundColor: 'white', borderRadius: 'var(--radius-lg)', padding: 'var(--space-8)', boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)' }}>
          <h1 className="text-4xl md:text-5xl mb-8" style={{ color: 'var(--color-text)', fontFamily: 'var(--font-heading)', fontWeight: 'var(--weight-bold)' }}>
            Terms and Conditions
          </h1>

          <div className="space-y-6" style={{ color: 'var(--color-text)' }}>
            <section>
              <h2 className="text-2xl font-semibold mb-4" style={{ color: 'var(--color-text)', fontFamily: 'var(--font-heading)' }}>
                Data Privacy and Security
              </h2>
              <p className="text-lg leading-relaxed" style={{ color: 'var(--color-text)', opacity: 0.9 }}>
                We do not sell any data to anyone. Your privacy is most important to us. We are committed to protecting your personal information and ensuring that all data is handled with the highest standards of security and confidentiality.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4" style={{ color: 'var(--color-text)', fontFamily: 'var(--font-heading)' }}>
                Therapeutic Use
              </h2>
              <p className="text-lg leading-relaxed" style={{ color: 'var(--color-text)', opacity: 0.9 }}>
                This app is intended for use with Therapists and is not a replacement for therapists. TheraEngage is designed to support and enhance the therapeutic relationship between therapists and their clients, but it should never be used as a substitute for professional mental health care or therapy sessions.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4" style={{ color: 'var(--color-text)', fontFamily: 'var(--font-heading)' }}>
                Electronic Health Records (EHR)
              </h2>
              <p className="text-lg leading-relaxed" style={{ color: 'var(--color-text)', opacity: 0.9 }}>
                This is not an Electronic Health Record (EHR) system. Users can download their content as PDF and add it to their EHR system. TheraEngage provides tools for tracking and managing therapeutic activities, but it is the responsibility of therapists to maintain official health records in their designated EHR systems.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4" style={{ color: 'var(--color-text)', fontFamily: 'var(--font-heading)' }}>
                Client Invitations and Consent
              </h2>
              <p className="text-lg leading-relaxed" style={{ color: 'var(--color-text)', opacity: 0.9 }}>
                Therapists must obtain permission from users before inviting them to the app. It is essential that therapists receive explicit consent from their clients before adding them to TheraEngage. This ensures that all users are aware of and agree to participate in the platform.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4" style={{ color: 'var(--color-text)', fontFamily: 'var(--font-heading)' }}>
                Emergency Situations
              </h2>
              <p className="text-lg leading-relaxed" style={{ color: 'var(--color-text)', opacity: 0.9 }}>
                In case of any emergency, dial relevant Emergency services. TheraEngage is not designed to handle emergency situations. If you or someone you know is experiencing a mental health emergency, please contact your local emergency services immediately (e.g., 911 in the United States) or reach out to a crisis helpline.
              </p>
            </section>
          </div>

          <div className="mt-12 pt-8" style={{ borderTop: '1px solid rgba(0, 0, 0, 0.1)' }}>
            <p className="text-sm" style={{ color: 'var(--color-text)', opacity: 0.7 }}>
              Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;

